import React from "react";
import { useLocation } from "react-router";
import NavBar from "../components/layout/NavBar";
import FinanceiroOrganizador from "../components/financeiro/FinanceiroOrganizador";
import FinanceiroBRV from "../components/financeiro/FinanceiroBRV";
import Footer from "../components/layout/Footer";

function Financeiro() {
    const location = useLocation();
    const caminhoAtual = location.pathname;

    const renderizarConteudo = () => {
        if (caminhoAtual === '/financeiro') {
            return <FinanceiroOrganizador />;
        } else if (caminhoAtual === '/financeiro-brv') {
            return <FinanceiroBRV />;
        }
        return <h2 className="text-center text-red-400 py-10 font-bold">Erro: Rota não mapeada.</h2>;
    };

    return (
        <div className="min-h-screen flex flex-col justify-between bg-urb-dark text-white">
            <header>
                <NavBar />
            </header>
            <main className="flex-grow max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
                {renderizarConteudo()}
            </main>
            <Footer />
        </div>
    );
}

export default Financeiro;